import React from 'react';

import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';

import { useCurrentTracklog, useAnalytics } from 'ff/debrief/hooks';
import { useDebriefModal } from 'ff/debrief/modalManager';
import { useDeleteTracklogMutation } from 'ff/debrief/features/TracklogApi';
import DebriefDialogTitle from 'ff/debrief/components/modals/DebriefDialogTitle';

const DeleteTracklogModal = () => {
    const { isOpen, close } = useDebriefModal('DeleteTracklog');
    const { logEvent } = useAnalytics();

    const { tracklog: tl, deselect } = useCurrentTracklog();

    const [deleteTracklog, deleteStatus] = useDeleteTracklogMutation();

    const handleSubmit = () => {
        deleteTracklog(tl.trackUuid);
        deselect();
        logEvent('Debrief, Track Log Deleted');
        handleClose();
    };

    const handleClose = () => {
        close();
    };

    if (!tl) return null;
    return (
        <Dialog open={isOpen} onClose={handleClose} maxWidth="xs" fullWidth>
            <DebriefDialogTitle onClose={handleClose}>
                Delete
            </DebriefDialogTitle>
            <DialogContent>
                <Typography>
                    {tl?.logbookAssociationDetails?.length > 0
                        ? 'The selected tracklog is associated with a logbook entry.' +
                          ' It will be unlinked from the logbook entry and permanently removed from all devices on your account.' +
                          ' This action cannot be undone.'
                        : 'The selected Track Log will be permanently removed from all\n' +
                          '                    devices on your account. This action cannot be undone.'}
                </Typography>
                <Typography>Are you sure you want to delete?</Typography>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={handleClose}
                    disabled={deleteStatus.isLoading}
                    variant="outlined"
                    color="info"
                    size="small"
                >
                    Cancel
                </Button>
                <Button
                    onClick={handleSubmit}
                    disabled={deleteStatus.isLoading}
                    variant="contained"
                    color="error"
                    size="small"
                >
                    Delete
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeleteTracklogModal;
